import { render, staticRenderFns } from "./AppointmentModificationConfirmation.vue?vue&type=template&id=0e67e0c4"
import script from "./AppointmentModificationConfirmation.vue?vue&type=script&lang=ts"
export * from "./AppointmentModificationConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports